export function pageTitle() {
    return `
    .title-section {
        h2 {
          max-width: 770px;
          margin: 0 auto 50px auto;
          font-family: var(--bllink-font-headers);
          font-size: 42px;
          line-height: 62px;
          text-align: center;
          color: #373647;
        }
        .building-title {
          display: block;
          color: var(--bllink-purple);
        }
    }
    
    .page-title{
          text-transform: capitalize;
        }
  `;
}
